import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ManageInvoiceRecipientsService {

  constructor(private httpClient: HttpClient) {
  }

  getFinanceUsersAndServiceCategories(companyUniqid: string): Observable<any[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/manage-invoice-recipients/' + companyUniqid);
  }

  updateFinanceUsers(companyUniqid: string, recipients: any): Observable<any> {
    return this.httpClient.post(environment.baseUrlWs + '/api/manage-invoice-recipients/' + companyUniqid, {recipients});
  }

  getMckayEntities(companyUniqid: string): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/mckay-entities/' + companyUniqid);
  }

  checkLastUserInInvoiceRecipients(userUniqid: string): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/check-last-user-invoice-recipients/' + userUniqid);
  }

  addMckayEntitiesToCompany(companyUniqid: string, mckayEntityUuids: string[]): Observable<any> {
    return this.httpClient.post(environment.baseUrlWs + '/api/add-mckay-entities-to-company/' + companyUniqid, {mckayEntityUuids});
  }
}
